module.exports = __webpack_public_path__ + "static/media/children.641b3bcc.svg";